import React, {lazy, Suspense} from 'react';
import {render} from 'react-dom';
import {BrowserRouter} from 'react-router-dom';

import {CURRENT_BASE} from '../golos/constants';
import {ModalProvider} from '../golos/contexts/ModalContext';
import RecaptchaTokenProvider from '../golos/contexts/RecaptchaContext';
import {UserVotesProvider} from '../golos/contexts/UserVotesContext';
import {isGolosNarodaInDevelopment} from '../golos/helpers';

const App = lazy(() => import('../golos'));
const Stub = lazy(() => import('../golos/components/stub/stub'));

const rootElement = document.getElementById('app-gn');
const callAuthModal = () => history.push('/login');

if (isGolosNarodaInDevelopment) {
  render(<Suspense fallback={null}><Stub /></Suspense>, rootElement);
} else {
  render(
    <Suspense fallback={null}>
      <BrowserRouter basename={CURRENT_BASE}>
        <RecaptchaTokenProvider>
          <ModalProvider callAuthModal={callAuthModal}>
            <UserVotesProvider>
              <App />
            </UserVotesProvider>
          </ModalProvider>
        </RecaptchaTokenProvider>
      </BrowserRouter>
    </Suspense>, rootElement);
}
